var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-action-button",class:{
  'base-action-button_add-icon': _vm.isAddButton,
  'base-action-button_bg': _vm.bg,
},attrs:{"disabled":_vm.disabled},on:{"click":(e) => _vm.$emit('onButtonClicked', e)}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }